/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { Component, Input } from '@angular/core';
import { IApplicationLog } from 'generated-types';
import { DurationProperty } from '../../vs-logs.types';

import './vs-log-duration-bar.component.less';
import { VsLogsDurationDetailService } from '../../services/vs-logs-duration-detail.service';

/**
 * @description
 * Renders a bar to indicate the time duration of waf, client, server, app respones,
 * and data transfer in vs logs list page.
 *
 * @author Shanmukha Sarath Kondiparthi
 */
@Component({
    selector: 'vs-log-duration-bar',
    templateUrl: 'vs-log-duration-bar.component.html',
})
export class VsLogDurationBarComponent {
    @Input()
    public largestTotalTime: number;

    @Input()
    public vsLog: IApplicationLog;

    @Input()
    public filter: DurationProperty;

    public DurationProperty = DurationProperty;

    public readonly percentage = {
        [DurationProperty.waf]: 0,
        [DurationProperty.clientRtt]: 0,
        [DurationProperty.serverRtt]: 0,
        [DurationProperty.appResponseTime]: 0,
        [DurationProperty.dataTransferTime]: 0,
    };

    constructor(private readonly vsLogsDurationDetailService: VsLogsDurationDetailService) {}

    public ngOnChanges(): void {
        const { vsLog, largestTotalTime } = this;

        this.percentage[DurationProperty.waf] =
            Number(this.vsLogsDurationDetailService.getWafTime(vsLog)) * 100 / largestTotalTime;
        this.percentage[DurationProperty.clientRtt] =
            Number(vsLog.client_rtt) * 100 / largestTotalTime;
        this.percentage[DurationProperty.serverRtt] =
            Number(vsLog.server_rtt) * 100 / largestTotalTime;
        this.percentage[DurationProperty.appResponseTime] =
            Number(vsLog.app_response_time) * 100 / largestTotalTime;
        this.percentage[DurationProperty.dataTransferTime] =
            Number(vsLog.data_transfer_time) * 100 / largestTotalTime;
    }
}
